import { routes } from './routes';

export const isSectionRoute = (pathname: string) => pathname.startsWith(`${routes.menu}/section/`);

export const isRecentItemsRoute = (pathname: string) => pathname.startsWith(routes.menuRecent);

export const isFavoritesRoute = (pathname: string) => pathname.startsWith(routes.favorites);

export const isOfferItemRoute = (pathname: string) => {
  const prefix = `${routes.loyaltyOfferList}/`;
  if (!pathname.startsWith(prefix)) {
    return false;
  }

  const rest = pathname.slice(prefix.length).replace(/\/$/, '');
  return Boolean(rest && rest !== 'group' && !rest.startsWith('group/') && !rest.includes('/'));
};

export const isItemPickerOrComboRoute = (pathname: string) =>
  new RegExp(`(item|picker|combo)/`).test(pathname);

/** Menu item / combo / product detail modal (`/menu/item|:id`, etc.). */
export const isMenuObjectDetailRoute = (pathname: string) =>
  new RegExp(`^${routes.menu}/(item|combo|picker|product)(/|$)`, 'i').test(pathname);
